export const MODEL_OPTIONS = [
	{ id: "haiku", label: "Haiku", hint: "Fast" },
	{ id: "sonnet", label: "Sonnet", hint: "Balanced" },
	{ id: "opus", label: "Opus", hint: "Deep" },
] as const;

export type ChatModelId = (typeof MODEL_OPTIONS)[number]["id"];

const STORAGE_KEY = "mairko-matrix-chat-model-v2";

export function readStoredModel(): ChatModelId {
	try {
		const raw = localStorage.getItem(STORAGE_KEY);
		if (raw === "haiku" || raw === "opus" || raw === "sonnet") return raw;
	} catch {
		/* ignore */
	}
	return "haiku";
}

export function writeStoredModel(modelId: ChatModelId): void {
	try {
		localStorage.setItem(STORAGE_KEY, modelId);
	} catch {
		/* ignore */
	}
}

export function isChatModelId(value: string): value is ChatModelId {
	return value === "haiku" || value === "sonnet" || value === "opus";
}
